import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatErr } from "../lib/api";
import { ArrowLeft, Check, X, Edit3, Trash2, Plus } from "lucide-react";

export default function AdminContent() {
  const [items, setItems] = useState([]);
  const [err, setErr] = useState(null);
  const [editing, setEditing] = useState(null);
  const [filter, setFilter] = useState("all");
  const [q, setQ] = useState("");

  const load = async () => {
    try { const r = await api.get("/admin/idioms"); setItems(r.data); }
    catch (e) { setErr(formatErr(e)); }
  };
  useEffect(() => { load(); }, []);

  const filtered = items.filter((i) => {
    if (filter === "verified" && i.verification_status !== "verified") return false;
    if (filter === "unverified" && i.verification_status !== "unverified") return false;
    if (filter === "published" && i.publication_status !== "published") return false;
    if (q && !`${i.idiom} ${i.artist} ${i.song}`.toLowerCase().includes(q.toLowerCase())) return false;
    return true;
  });

  const toggle = async (it, field, value) => {
    try {
      await api.put(`/admin/idioms/${it.id}`, { ...it, [field]: value });
      await load();
    } catch (e) { alert(formatErr(e)); }
  };
  const del = async (it) => {
    if (!confirm("Silinsin mi?")) return;
    await api.delete(`/admin/idioms/${it.id}`); await load();
  };

  return (
    <div className="min-h-screen dark bg-[#070B14] text-white">
      <div className="max-w-6xl mx-auto px-6 py-10">
        <Link to="/teacher" className="text-zinc-400 text-sm inline-flex items-center gap-1"><ArrowLeft className="h-4 w-4"/> Panel</Link>
        <div className="mt-6 flex items-end justify-between gap-4">
          <div>
            <h1 className="font-heading text-4xl font-bold">İçerik Yönetimi</h1>
            <p className="text-zinc-400 text-sm mt-1">Yalnızca <span className="text-white">deyim olduğu ve ilgili şarkıda geçtiği doğrulanan</span> içerikleri yayımlayın.</p>
          </div>
          <button onClick={() => setEditing({ new: true, pack_key: "karisik", artist: "", song: "", idiom: "", meaning: "", grade_level: "9-10" })}
                  className="rounded-full bg-white text-black font-heading font-bold px-4 py-2 flex items-center gap-2" data-testid="add-idiom-btn">
            <Plus className="h-4 w-4"/> Ekle
          </button>
        </div>

        <div className="mt-6 flex gap-2 flex-wrap items-center">
          {["all","verified","unverified","published"].map((f) => (
            <button key={f} onClick={() => setFilter(f)}
                    className={`px-3 py-1 rounded-full text-xs border ${filter===f ? "border-cyan-400 text-cyan-300" : "border-white/10 text-zinc-400"}`}>{f}</button>
          ))}
          <input value={q} onChange={(e)=>setQ(e.target.value)} placeholder="Ara…" className="ml-auto rounded-lg bg-black/60 border border-white/10 px-3 py-1 text-sm"/>
        </div>

        {err && <div className="mt-4 text-red-300 text-sm">{err}</div>}

        <div className="mt-6 rounded-2xl border border-white/10 overflow-hidden">
          <div className="grid grid-cols-12 text-[11px] uppercase tracking-widest text-zinc-500 border-b border-white/5 px-4 py-2">
            <div className="col-span-4">Deyim / Şarkı</div>
            <div className="col-span-2">Paket</div>
            <div className="col-span-2">Doğrulama</div>
            <div className="col-span-2">Yayın</div>
            <div className="col-span-2 text-right">İşlem</div>
          </div>
          {filtered.map((it) => (
            <div key={it.id} className="grid grid-cols-12 items-center px-4 py-3 border-b border-white/5 text-sm">
              <div className="col-span-4">
                <div className="font-literary italic">"{it.idiom}"</div>
                <div className="text-zinc-500 text-xs">{it.artist} — {it.song}</div>
              </div>
              <div className="col-span-2 text-zinc-300">{it.pack_key}</div>
              <div className="col-span-2">
                <button onClick={() => toggle(it, "verification_status", it.verification_status === "verified" ? "unverified" : "verified")}
                        className={`px-2 py-1 rounded-full text-xs border ${it.verification_status === "verified" ? "border-emerald-400 text-emerald-300" : "border-white/10 text-zinc-400"}`}>
                  {it.verification_status === "verified" ? "Doğrulandı" : "Doğrulanmadı"}
                </button>
              </div>
              <div className="col-span-2">
                <button onClick={() => toggle(it, "publication_status", it.publication_status === "published" ? "draft" : "published")}
                        className={`px-2 py-1 rounded-full text-xs border ${it.publication_status === "published" ? "border-cyan-400 text-cyan-300" : "border-white/10 text-zinc-400"}`}>
                  {it.publication_status === "published" ? "Yayında" : "Taslak"}
                </button>
              </div>
              <div className="col-span-2 flex justify-end gap-2">
                <button onClick={() => setEditing(it)} className="text-zinc-400 hover:text-white" data-testid={`edit-${it.id}`}><Edit3 className="h-4 w-4"/></button>
                <button onClick={() => del(it)} className="text-zinc-400 hover:text-red-300"><Trash2 className="h-4 w-4"/></button>
              </div>
            </div>
          ))}
          {filtered.length === 0 && <div className="p-6 text-zinc-500 text-sm">Kayıt yok.</div>}
        </div>
      </div>

      {editing && <IdiomEditor item={editing} onClose={() => { setEditing(null); load(); }} />}
    </div>
  );
}

function IdiomEditor({ item, onClose }) {
  const [form, setForm] = useState({
    pack_key: item.pack_key, artist: item.artist, song: item.song,
    idiom: item.idiom, meaning: item.meaning, grade_level: item.grade_level || "9-10",
    youtube_url: item.youtube_url || "", youtube_start: item.youtube_start || 0,
  });
  const [saved, setSaved] = useState(!item.new);
  const [id, setId] = useState(item.id || null);
  const [qs, setQs] = useState(item.questions || {});
  const [err, setErr] = useState(null);

  const save = async () => {
    setErr(null);
    try {
      if (!id) {
        const r = await api.post("/admin/idioms", form);
        setId(r.data.id); setSaved(true);
      } else {
        await api.put(`/admin/idioms/${id}`, { ...form });
      }
    } catch (e) { setErr(formatErr(e)); }
  };

  const saveQ = async (stage, payload) => {
    setErr(null);
    try {
      await api.put(`/admin/idioms/${id}/question`, { idiom_id: id, stage, ...payload });
      setQs((prev) => ({ ...prev, [stage]: { ...payload } }));
    } catch (e) { setErr(formatErr(e)); }
  };

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="w-full max-w-3xl rounded-3xl bg-zinc-950 border border-white/10 max-h-[90vh] overflow-y-auto">
        <div className="p-6 border-b border-white/5 flex items-center justify-between">
          <div className="font-heading font-bold text-xl">{item.new ? "Yeni Deyim" : "Deyimi Düzenle"}</div>
          <button onClick={onClose} className="text-zinc-400 hover:text-white"><X className="h-5 w-5"/></button>
        </div>
        <div className="p-6 space-y-4">
          <div className="grid grid-cols-2 gap-3">
            <Field label="Paket"><select value={form.pack_key} onChange={(e)=>setForm({...form,pack_key:e.target.value})} className="w-full rounded-lg bg-black/60 border border-white/10 px-3 py-2">
              <option value="tarkan">TARKAN ÖZEL</option>
              <option value="baris_manco">BARIŞ MANÇO ÖZEL</option>
              <option value="karisik">KARIŞIK ŞARKILAR</option>
            </select></Field>
            <Field label="Sınıf"><select value={form.grade_level} onChange={(e)=>setForm({...form,grade_level:e.target.value})} className="w-full rounded-lg bg-black/60 border border-white/10 px-3 py-2">
              <option value="9-10">9–10 Karışık</option><option value="9">9</option><option value="10">10</option></select></Field>
            <Field label="Sanatçı"><input value={form.artist} onChange={(e)=>setForm({...form,artist:e.target.value})} className="w-full rounded-lg bg-black/60 border border-white/10 px-3 py-2"/></Field>
            <Field label="Şarkı"><input value={form.song} onChange={(e)=>setForm({...form,song:e.target.value})} className="w-full rounded-lg bg-black/60 border border-white/10 px-3 py-2"/></Field>
          </div>
          <Field label="Deyim"><input value={form.idiom} onChange={(e)=>setForm({...form,idiom:e.target.value})} className="w-full rounded-lg bg-black/60 border border-white/10 px-3 py-2"/></Field>
          <Field label="Anlam"><textarea value={form.meaning} onChange={(e)=>setForm({...form,meaning:e.target.value})} rows={2} className="w-full rounded-lg bg-black/60 border border-white/10 px-3 py-2"/></Field>
          <div className="grid grid-cols-1 gap-3">
            <Field label="🎵 YouTube URL (sadece link — indirilmez, kopyalanmaz)">
              <input
                value={form.youtube_url}
                onChange={(e)=>setForm({...form,youtube_url:e.target.value})}
                placeholder="https://www.youtube.com/watch?v=..."
                data-testid="youtube-url-input"
                className="w-full rounded-lg bg-black/60 border border-white/10 px-3 py-2"/>
            </Field>
          </div>
          <div className="text-xs text-zinc-500 -mt-2">
            Şarkı baştan sona bir kez dinletilir — başlangıç saniyesi kullanılmaz. Uygulama sesi indirmez, kopyalamaz, aktarmaz.
          </div>
          <button onClick={save} className="rounded-full bg-white text-black font-heading font-bold px-4 py-2" data-testid="save-idiom">Kaydet</button>
          {err && <div className="text-red-300 text-sm">{err}</div>}

          {saved && id && (
            <div className="mt-6 space-y-6">
              {["idiom","meaning","context"].map((stage) => (
                <QuestionForm key={stage} stage={stage} current={qs[stage]} onSave={(p) => saveQ(stage, p)} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const Field = ({ label, children }) => (
  <label className="block">
    <div className="text-xs text-zinc-500 mb-1 font-heading tracking-wider">{label.toUpperCase()}</div>
    {children}
  </label>
);

function QuestionForm({ stage, current, onSave }) {
  const [text, setText] = useState(current?.text || "");
  const [opts, setOpts] = useState(current?.options || ["","","","",""]);
  const [correct, setCorrect] = useState(current?.correct || "A");
  const labels = { idiom: "🎧 Deyimi Yakala", meaning: "💭 Anlamını Yakala", context: "🧠 Bağlamı Yakala" };
  return (
    <div className="rounded-2xl border border-white/10 p-4">
      <div className="font-heading text-sm text-cyan-300">{labels[stage]}</div>
      <textarea value={text} onChange={(e)=>setText(e.target.value)} placeholder="Soru metni" rows={2} className="mt-2 w-full rounded-lg bg-black/60 border border-white/10 px-3 py-2"/>
      <div className="mt-3 grid gap-2">
        {["A","B","C","D","E"].map((L, i) => (
          <div key={L} className="flex items-center gap-2">
            <button onClick={() => setCorrect(L)} className={`w-8 h-8 rounded-full border font-heading text-xs ${correct===L ? "bg-emerald-500/20 border-emerald-400 text-emerald-300" : "border-white/10 text-zinc-400"}`}>{L}</button>
            <input value={opts[i]} onChange={(e)=>{ const n=[...opts]; n[i]=e.target.value; setOpts(n); }} placeholder={`Seçenek ${L}`} className="flex-1 rounded-lg bg-black/60 border border-white/10 px-3 py-2"/>
          </div>
        ))}
      </div>
      <button onClick={() => onSave({ text, options: opts, correct })} className="mt-3 text-sm rounded-full bg-cyan-500/20 border border-cyan-400/40 text-cyan-200 px-3 py-1">Soruyu Kaydet</button>
    </div>
  );
}
